module.exports = __webpack_public_path__ + "static/img/dDR5.bf94ac79.png";